import { FaqRequestParams, FaqInsertRequest, FaqUpdateRequest, FaqUpdateAltQueRequest, FaqInsertAltQueRequest } from 'model/faq/faq.request';
import { FaqResponse } from 'model/faq/faq.response';
import { ApiConfig } from 'config/api.config';
import { convertBriteClient } from 'utils/convertBriteClient';

/**
 * Fetches FAQs from the API
 * @param params Request parameters for pagination and client ID
 * @returns Promise with FAQ data
 */
export const getFaqs = async (params: FaqRequestParams): Promise<FaqResponse> => {
  try {
    // Use the ConvertBriteClient to make the API request
    const data = await convertBriteClient.post<FaqResponse>(ApiConfig.FAQS, params);
    
    // Return the FAQs response
    return data;
  } catch (error) {
    console.error('Error fetching FAQs:', error);
    // Return empty response structure
    return {
      all_faqs: [],
      publish_count: 0,
      draft_count: 0,
      trash_count: 0,
      total_faqs: 0
    };
  }
};

/**
 * Inserts a new FAQ via multipart form POST to /api/faq_insert
 */
export const insertFaq = async (params: FaqInsertRequest): Promise<any> => {
  const formData = new FormData();
  formData.append('client_id', String(params.client_id));
  formData.append('ques', params.ques);
  formData.append('ans', params.ans);

  if (params.tags) {
    formData.append('tags', params.tags);
  }
  if (params.status) {
    formData.append('status', params.status);
  }
  if (params.alt_que) {
    formData.append('alt_que', params.alt_que);
  }

  const data = await convertBriteClient.post<any>(ApiConfig.FAQ_INSERT, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};

/**
 * Updates an existing FAQ via multipart form POST to /api/faq_update
 */
export const updateFaq = async (params: FaqUpdateRequest): Promise<any> => {
  const formData = new FormData();
  formData.append('faq_id', String(params.faq_id));
  formData.append('client_id', String(params.client_id));
  formData.append('ques', params.ques);
  formData.append('ans', params.ans);

  if (params.tags) {
    formData.append('tags', params.tags);
  }
  if (params.status) {
    formData.append('status', params.status);
  }
  if (params.alt_que) {
    formData.append('alt_que', params.alt_que);
  }

  const data = await convertBriteClient.post<any>(ApiConfig.FAQ_UPDATE, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};

/**
 * Adds or updates an alt question for a FAQ via JSON POST to /api/faq_update_alt_que
 */
export const updateFaqAltQue = async (params: FaqUpdateAltQueRequest): Promise<any> => {
  const data = await convertBriteClient.post<any>(ApiConfig.FAQ_UPDATE_ALT_QUE, params);
  return data;
};

export const insertFaqAltQue = async (params: FaqInsertAltQueRequest): Promise<any> => {
  const data = await convertBriteClient.post<any>(ApiConfig.FAQ_INSERT_ALT_QUE, params);
  return data;
};
